import { useState } from "react";

import CircularProgress from "@mui/material/CircularProgress";
import FormControlLabel from "@mui/material/FormControlLabel"
import Grid from "@mui/material/Grid"
import Radio from "@mui/material/Radio"
import RadioGroup from "@mui/material/RadioGroup"

import { preferenceArray } from "../../app/constants/constants";
import { setUser, userSelector } from "../../app/main/mainSlice";
import { useAppDispatch, useAppSelector } from "../../app/store/hooks";
import useUserPreference from "../../utils/globalSettings/usePreferenceQuery";
import useHomePageJson from "../newHomePage/utils/useHomePageJson";
import { TextPrimary } from "../typography";
import styles from "./userPreference.module.css";

const DietSelector = ({ setDrawer }: { setDrawer: React.Dispatch<React.SetStateAction<boolean>> }) => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(userSelector);
  const { updatingUserSettings, loading: settingDiet } = useUserPreference();
  const [userSelectedDiet, setUserSelectedDiet] = useState<string>(user?.userSettings?.diet || 'nonVeg');
  const { fetchHomePage, loading: fetchingJson } = useHomePageJson(true);

  const handleSelectUserSettings = async (settings: { diet: string; allergens?: string[] | undefined }) => {
    if (user?.id && settings.diet !== user?.userSettings?.diet) {
      await updatingUserSettings(user?.id, settings, () => {
        dispatch(setUser({ user: { ...user, userSettings: settings } }));
      });

      await fetchHomePage(settings?.diet);
    }

    setDrawer(false);
  };

  const handleDietSelection = (newDiet: string) => {
    setUserSelectedDiet(newDiet);

    if (newDiet === userSelectedDiet) {
      setDrawer(false);
      return;
    }

    const userSettings = { ...user?.userSettings, diet: newDiet };

    handleSelectUserSettings(userSettings);
  };

  return (
    <Grid
      className={styles.dietSelectorContainer}
    >
      {(settingDiet || fetchingJson) ?
        <Grid className={styles.dietDrawerOverlay}>
          <CircularProgress color="inherit" disableShrink size={20}
variant='indeterminate' /><TextPrimary text="Applying diet" />
        </Grid> : null
      }
      <RadioGroup
        aria-disabled="true"
        aria-labelledby="demo-radio-buttons-group-label"
        onChange={(e) => handleDietSelection(e.target.value)}
        value={userSelectedDiet}
      >
        {preferenceArray.map((filterValue) => (
          <FormControlLabel
            control={<Radio />}
            disabled={settingDiet || fetchingJson}
            key={filterValue.type}
            label={<TextPrimary text={filterValue.settingsTitle} />}
            value={filterValue.type}
          />
        ))}
      </RadioGroup>
    </Grid>
  );
};

export default DietSelector;
